import { MsalService } from '@azure/msal-angular';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MicrosoftAuthService } from '../../data/service/auth/microsoft-auth.service';
import { UserService } from '../../data/service/user.service';

@Injectable({
  providedIn: 'root'
})
export class MicrosoftLoginGuard implements CanActivate {
  constructor(
    private authService: MsalService,
    private router: Router,
    private microsoftAuthService: MicrosoftAuthService,
    private userService: UserService
  ) { }

  canActivate( route:ActivatedRouteSnapshot, state:RouterStateSnapshot) : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.debug('[GUARD] MicrosoftLoginGuard.canActivate() - entrando, ruta=', state.url);
    // Verificar cuenta activa
    let activeAccount = this.authService.instance.getActiveAccount();
    const allAccounts = this.authService.instance.getAllAccounts();

    console.debug('[GUARD] cuentas MSAL disponibles:', allAccounts.length, 'activeAccount inicial:', !!activeAccount);

    // Verificar si la app tiene info de usuario (UserService)
    const userInfo = this.userService.getUserInfo();
    const isAppLogged = !!(userInfo && (userInfo.email || userInfo.nombre_usuario));
    console.debug('[GUARD] userService.getUserInfo():', userInfo, 'isAppLogged=', isAppLogged);

    // Si no hay cuenta activa pero existen cuentas MSAL, establecer la primera
    if (!activeAccount && allAccounts.length > 0) {
      console.debug('[GUARD] estableciendo primera cuenta MSAL disponible como activeAccount');
      activeAccount = allAccounts[0];
      this.authService.instance.setActiveAccount(activeAccount);
      console.debug('[GUARD] activeAccount ahora:', activeAccount?.username ?? activeAccount?.homeAccountId);
    }

    // Si la app cree que está logueada pero MSAL no tiene cuentas, limpiar estado
    if (isAppLogged && !activeAccount && allAccounts.length === 0) {
      console.warn('[GUARD] inconsistencia detectada: app cree que está logueada pero MSAL no tiene cuentas. Limpiando estado.');
      this.microsoftAuthService.clearAuthState();
    }

    if (!activeAccount && !isAppLogged) {
      console.debug('[GUARD] Acceso denegado - no hay sesión activa. Redirigiendo a /login');
      this.router.navigate(['/login']);
      return false;
    }

    console.debug('[GUARD] Acceso permitido por MicrosoftLoginGuard');
    return true;
  }
}
